import { defineMessages } from 'react-intl';
import { ShipmentHelperService } from '../../../../../services/shipment-helper-service';
import { FulfillmentPlanOrderGridStatus } from '../../../../../enums/fulfillmentplan-order-grid-status';

const messages = defineMessages({
  sendNotifications: {
    description: 'shipmentDetailsOtherActions.sendNotifications',
    defaultMessage: 'Send Notifications',
    id: 'VEoInS',
  },
});

export const SendNotifications = {
  translation: messages.sendNotifications,

  handler: ({ actions }) => {
    const { sendNotifications } = actions;
    sendNotifications();
  },

  shouldBeShown: ({ shipmentStatus, orderGridStatus, enableNewEmailExperience }) => {
    if (enableNewEmailExperience) {
      return false;
    }
    const isShipped = orderGridStatus === FulfillmentPlanOrderGridStatus.Shipped.name;
    return isShipped && !ShipmentHelperService.anyNotificationErrored(shipmentStatus);
  },
};
